<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

const Default = defineAsyncComponent(() => import('@/views/layouts/Default.vue'));
const Link = defineAsyncComponent(() => import('@/views/components/Link.vue'));
const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL
const header_image = `${VITE_ASSET_URL}assets/public/assets/img/blog/DevisImportant.jpg`
const header_image_mobile = `${VITE_ASSET_URL}assets/public/assets/img/blog/DevisImportantMobile.jpg`

</script>

<template>
    <Default>
            <div class="app-content content bg-white pt-5" style="min-height: 73vh; margin-left: 0px"> 
                <div class="content-wrapper container bg-white h-100 pt-0 pt-md-5">
                    <main id="main pt-5">
                        <h2 class="text-center mt-5">Comment faire un devis en tant qu’artisan ? Guide complet 2025</h2>
                        <p class="text-center mb-5">Découvrez comment rédiger un devis clair et conforme aux normes en 2025. TVA, mentions obligatoires et outils pratiques : optimisez votre activité d’artisan !</p>
                        <img 
                            class="mt-2 d-none d-lg-block rounded-4" 
                            :src="header_image" 
                            style="width: 100%; aspect-ratio: 16 / 5;" 
                            alt="Devis important">
                        <img 
                            class="mt-2 d-block d-lg-none rounded-4" 
                            :src="header_image_mobile" 
                            style="width: 100%; aspect-ratio: 16 / 5;" 
                            alt="Devis important">

                        <section>
                            <div class="row">
                                <div class="d-block d-lg-none col-lg-4 mb-5 border-black border-top-0 border-end-0 border-start-0 pb-3">
                                    <div class="row">
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Auteur :</p>
                                            <p><strong>Matteo MONDI</strong></p>
                                        </div>
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Catégorie :</p>
                                            <p><strong>Devis Artisan</strong></p>
                                        </div>
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Temps de lecture :</p>
                                            <p><strong>2 minutes</strong></p>
                                        </div>
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Dernière modification :</p>
                                            <p><strong>08 mars 2025</strong></p>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-none d-lg-block col-lg-3 mb-5">
                                    <div class="row">
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Auteur :</p>
                                            <p><strong>Matteo MONDI</strong></p>
                                        </div>
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Catégorie :</p>
                                            <p><strong>Devis Artisan</strong></p>
                                        </div>
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Temps de lecture :</p>
                                            <p><strong>2 minutes</strong></p>
                                        </div>
                                        <div class="col-6 col-lg-12 mb-lg-3">
                                            <p>Dernière modification :</p>
                                            <p><strong>19 mars 2025</strong></p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-9 px-3 border-black border-top-0 border-end-0 border-bottom-0">
                                    <div>
                                        <!-- <p class="mb-4">
                                            Que vous soyez en micro-entreprise, EURL, SARL ou autre, la gestion des clients demande du temps et de l’organisation. C’est pourquoi des solutions comme topela permettent aux artisans de centraliser leurs demandes, automatiser leurs devis et factures, et assurer un suivi efficace, sans perdre de temps sur l’administratif.
                                            Découvrez les meilleures stratégies pour entretenir une relation client de qualité et comment topela peut vous aider au quotidien, quel que soit votre statut juridique.
                                        </p> -->
                                        <h4 class="mb-3">
                                            1. Pourquoi un devis est indispensable pour un artisan ? 
                                        </h4>
                                        <h5>Un document obligatoire dans certains cas </h5>
                                        <p class="mb-4">
                                            Il informe le client du coût et du détail des travaux, tout en protégeant l’artisan en cas de litige. Un document signé devient une preuve juridique incontestable en cas de contestation. 
                                        </p>
                                        <ul class="mb-3">
                                            <li>
                                                Obligatoire pour les prestations de services artisanales (bâtiment, réparation, dépannage) dès que le montant dépasse 150€. 
                                            </li>
                                            <li>
                                                Recommandé pour toutes les autres activités afin de clarifier l’accord et éviter les malentendus.
                                            </li>
                                            <li>
                                                Engage les deux parties dès sa signature.
                                            </li>
                                        </ul>
                                        <div class="p-4 bg-blue rounded-3 mb-4">
                                            <p class="text-white">
                                                Grâce à un devis bien structuré, vous évitez les litiges. Si un client mécontent vous reproche des frais supplémentaires sur une installation de cuisine, le devis signé vous permet de prouver que ces coûts avaient bien été mentionnés et validés à l’avance.
                                                <br>Source officielle : economie.gouv.fr 
                                            </p>
                                        </div>
                                    </div>

                                    <div class="mt-5">
                                        <h4 class="mb-3">
                                            2. Les mentions obligatoires d’un devis artisan  
                                        </h4>
                                        <h5>Les informations essentielles à inclure</h5>
                                        <p class="mb-2">
                                            Un devis valide et conforme aux exigences légales doit contenir plusieurs éléments indispensables. Un oubli peut le rendre caduc et empêcher son application légale. 
                                        </p>
                                        <ul class="mb-3">
                                            <li>
                                                Identité de l’entreprise : nom, raison sociale, adresse, SIRET, coordonnées. 
                                            </li>
                                            <li>
                                                Identité du client : nom et adresse. 
                                            </li>
                                            <li>
                                                Détail des prestations : description, quantité et prix unitaire. 
                                            </li>
                                            <li>
                                                Montant total HT et TTC.  
                                            </li>
                                            <li>
                                                TVA applicable : mention obligatoire, avec exonération précisée si nécessaire (micro-entreprise, sous conditions). 
                                            </li>
                                            <li>
                                                Conditions de paiement et durée de validité. 
                                            </li>
                                        </ul>
                                        <div class="p-4 bg-blue rounded-3 mb-4">
                                            <p class="text-white">
                                                Un artisan du bâtiment a vu un client refuser son devis car il ne précisait pas son numéro SIRET et la durée de validité de l’offre. Après correction, il a pu finaliser le contrat sans difficulté. 
                                                <br>Source officielle : economie.gouv.fr
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div class="mt-5">
                                        <h4 class="mb-3">
                                            3. Comment réaliser un devis efficace et professionnel ?
                                        </h4>
                                        <h5>Étapes pour établir un devis clair et attractif </h5>
                                        <p class="mb-2">
                                            Un devis efficace doit être structuré et détaillé pour éviter les mauvaises surprises. L’objectif est d’apporter de la transparence et de rassurer le client sur l’ensemble des prestations. Rédiger un devis à la main prend du temps et augmente le risque d’erreur. Avec un outil automatisé, vous gagnez en précision et en efficacité. En utilisant un logiciel de devis automatisé, vous réduisez le temps que vous passez en gestion. 
                                        </p>
                                        <ul class="mb-3">
                                            <li>
                                                Échanger avec le client pour bien comprendre ses besoins et attentes. 
                                            </li>
                                            <li>
                                                Évaluer précisément les coûts des matériaux, de la main-d’œuvre et des déplacements. 
                                            </li>
                                            <li>
                                                Utiliser un logiciel ou un modèle de devis pour éviter les erreurs et gagner du temps. 
                                            </li>
                                            <li>
                                                Détaillez chaque prestation afin de lever toute ambiguïté et faciliter la comparaison.  
                                            </li>
                                            <li>
                                                Vérifier la conformité légale avant l’envoi. 
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="mt-5">
                                        <h4 class="mb-3">
                                            4. Les particularités pour les artisans du bâtiment
                                        </h4>
                                        <h5>Assurances et garanties obligatoires </h5>
                                        <p class="mb-2">
                                            Pour les artisans du bâtiment, certaines mentions spécifiques sont obligatoires afin de protéger les clients et sécuriser les projets.    
                                        </p>
                                        <ul class="mb-3">
                                            <li>
                                                Coordonnées de l’assureur et numéro de garantie décennale. 
                                            </li>
                                            <li>
                                                Nature et étendue des garanties proposées. 
                                            </li>
                                            <li>
                                                Délais d’exécution des travaux, avec possibilité d’indemnisation en cas de retard. 
                                            </li>
                                        </ul>
                                        <div class="p-4 bg-blue rounded-3 mb-4">
                                            <p class="text-white">
                                                Un artisan maçon s’est vu refuser un chantier par un client inquiet de l’absence de la garantie décennale sur son devis. Après explication et ajout de cette mention, le client s’est senti rassuré et a accepté la proposition.  
                                            </p>
                                        </div>
                                    </div>


                                    <div class="mt-5">
                                        <h4 class="mb-3">
                                            5. Les évolutions fiscales à prévoir en 2025 
                                        </h4>
                                        <h5>Changements sur la TVA pour les artisans </h5>
                                        <p class="mb-2">
                                            À partir de mars 2025, le seuil de franchise de TVA pour les micro-entrepreneurs pourrait être abaissé à 25 000 €. Ce changement impactera directement la facturation et la tarification des prestations.     
                                        </p>
                                        <ul class="mb-3">
                                            <li>
                                                Si votre chiffre d’affaires reste en dessous de 25 000 €, vous pouvez toujours indiquer <strong>"TVA non applicable, art. 293 B du CGI".</strong> 
                                            </li>
                                            <li>
                                                Au-delà de ce seuil, vous devrez appliquer et détailler la TVA sur vos devis et factures. 
                                            </li>
                                            <li>
                                                Certains travaux continueront de bénéficier de taux TVA réduits (5,5 % ou 10 % selon les prestations). 
                                            </li>
                                        </ul>
                                        <div class="p-4 bg-blue rounded-3 mb-4">
                                            <p class="text-white">
                                                Une auto-entrepreneuse en rénovation intérieure a anticipé cette réforme en informant ses clients via ses devis et en ajustant progressivement ses prix pour ne pas être pris au dépourvu. 
                                            </p>
                                        </div>
                                    </div>

                                    <div class="mt-5">
                                        <h4 class="mb-3">
                                            6. Utiliser des outils pour simplifier la création de devis
                                        </h4>
                                        <h5>Gagnez du temps avec topela</h5>
                                        <p class="mb-2">
                                            Un bon outil de gestion de devis permet aux artisans de se concentrer sur leur métier sans perdre des heures dans l’administratif. topela offre une solution clé en main pour :
                                        </p>
                                        <ul class="mb-4">
                                            <li>
                                                Créer des devis professionnels rapidement avec des modèles pré-remplis. 
                                            </li>
                                            <li>
                                                Gérer et suivre les demandes clients directement sur une seule interface. 
                                            </li>
                                            <li>
                                                Faciliter la signature et l’archivage des devis pour un meilleur suivi. 
                                            </li>
                                        </ul>
                                        <div class="p-4 bg-blue rounded-3 mb-4">
                                            <p class="text-white">
                                                Un électricien qui passait plusieurs heures par semaine sur ses devis a opté pour topela PRO et économise désormais un temps précieux en automatisant cette tâche.
                                            </p>
                                        </div>
                                    </div>

                                    <div class="mt-5">
                                        <h4 class="mb-3">
                                            Conclusion : Passez à l’action dès maintenant ! 
                                        </h4>
                                        <!-- <h5>Centralisez vos demandes avec topela </h5> -->
                                        <p class="mb-2">
                                            Rédiger un devis conforme et détaillé est essentiel pour sécuriser vos contrats et rassurer vos clients. En suivant les bonnes pratiques et en vous tenant informé des évolutions fiscales, vous mettez toutes les chances de votre côté pour développer votre activité.  
                                        </p>
                                        <ul class="mb-4">
                                            <li>
                                                Respectez les mentions légales obligatoires. 
                                            </li>
                                            <li>
                                                Anticipez les changements fiscaux pour 2025. 
                                            </li>
                                            <li>
                                                Utilisez des outils comme topela pour gagner du temps et éviter les erreurs.
                                            </li>
                                        </ul>
                                        <p class="mb-2">
                                            Passez à l’action dès aujourd’hui et optimisez la gestion de vos devis avec topela.
                                        </p>
                                    </div>


                                    <div>
                                        <div class="p-4 mt-5 bg-orange rounded-3 row align-items-center w-100 ms-1">
                                            <div class="text-white col-lg-8 d-flex align-items-center">
                                                <div>
                                                    <div class="rounded-circle border-white border-1 me-3 d-flex justify-content-center align-items-center" style="width: 45px; height: 45px;">
                                                        <span class="material-symbols-outlined">neurology</span>
                                                    </div>
                                                </div>
                                                <div class="text-white">
                                                    Découvrez comment topela donne des ailes aux petitis artisans du bâtiment.
                                                </div>
                                            </div>
                                            <div class="col-lg-4 text-center mt-2 mt-lg-0">
                                                <Link href="/pro/" type="button" class="btn menu-bg rounded-pill px-3 text-white">En savoir plus</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                </div>
            </div>
    </Default>
</template>

<style scoped>
@import url('@/assets/css/bootstrap-extended.css');
@import url('@/assets/css/animate.css');
@import url('@/assets/css/main.css');
@import url('@/assets/css/responsive.css');

.hero-background {
  height: 60vh;
  /* background-position: 25% center !important; */
  background-repeat: no-repeat !important;
  background-size: cover !important;
  margin-top: 5vh;
  position: relative;
}

ul {
  list-style-type: disc !important; /* Ensures bullets appear */
  padding-left: 20px; /* Adds space for bullets */
}

ul li {
    list-style: disc;
}

li {
  margin-bottom: 5px; /* Adds spacing between items */
}

li::marker {
  color: black !important; /* Sets bullet color to black */
  font-size: 1em; /* Adjusts bullet size (optional) */
}
</style>